<template>
  <stripe-account-error v-if="stripeAccountError" />
  <setup-wizard v-else-if="wizardReady && currentStep !== 'COMPLETED'" />
  <stripe-connect-dashboard v-else-if="wizardReady && currentStep === 'COMPLETED'" />
</template>

<script>
  import SetupWizard from "./SetupWizard";
  import StripeConnectDashboard from "./StripeConnectDashboard";
  import {mapActions, mapGetters} from "vuex";
  import StripeAccountError from "./StripeAccountError.vue";

  export default {
    components: {
      StripeAccountError,
      SetupWizard,
      StripeConnectDashboard,
    },
    props: {
      incompleteConfiguration: {
        type: [Object, null],
        default: null,
      },
      whitelabelLogo: {
        type: [String, null],
        default: null,
      },
      countries: {
        type: [Object, null],
        default: null,
      },
    },
    data() {
      return {
        wizardReady: false,
      }
    },
    computed: {
      ...mapGetters('merchantCentreSetupWizard', [
        'currentStep',
        'stripeAccountError',
      ]),
    },
    async mounted() {
      this.setWhitelabelLogo(this.whitelabelLogo);
      this.setCountries(this.countries);
      if (Object.keys(this.incompleteConfiguration).length > 0) {
        this.setIncompleteConfiguration(this.incompleteConfiguration);
      }
      await this.fetchWhitelabelStatus();
      this.wizardReady = true;
    },
    methods: {
      ...mapActions('merchantCentreSetupWizard', [
        'fetchWhitelabelStatus',
        'setIncompleteConfiguration',
        'setWhitelabelLogo',
        'setCountries',
      ]),
    }
  }
</script>
